module.exports = __webpack_public_path__ + "img/changjin-1.4acbbb81.png";